import React from "react";

//package import

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
} from "@mui/material";

//component

const DelModal = ({ status, open, handleClose,minitryDelHandler }) => {
  //hooks
  

  // render
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      // fullWidth={true}
      sx={{
        color: "gray",
        borderRadius: 2,
      }}
    >
      <DialogTitle>{}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center" }}>
          Are you sure you want to {status ? "active" : "inactive"} the
          ministry ?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ marginTop: 5, margin: "auto" }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          No
        </Button>

        <Button
          variant="contained"
          onClick={minitryDelHandler}
          sx={{
            backgroundColor: "gray",
            borderRadius: 2,
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DelModal;
